import { FC, ReactNode } from 'react';

interface Props {
   children: ReactNode;
}

export const TableBody: FC<Props> = ({ children }) => <tbody data-testid="table-body">{children}</tbody>;
